import { Injectable } from '@angular/core';

import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Subject, BehaviorSubject, map } from 'rxjs';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ModalOptimizationService } from '@app/modals/modal-optimization/modal-optimization.service';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  items;

  properties = {
    loan: {
      route: 'credit-buyback',
      idProperty: `id`,
      style: {
        backgroundColor: 'bg-danger',
        color: '#eb7373',
        icon: 'trending-down',
      },
      optimizationKey: 'LOAN_FIX_RATE',
    },
    assuranceVie: {
      route: 'life-insurance',
      idProperty: `current.id`,
      style: {
        backgroundColor: 'bg-danger',
        color: '#eb7373',
        icon: 'trending-down',
      },
      optimizationKey: 'LIFE_INSURANCE',
    },
    buyOrRent: {
      /* route: 'buy-or-rent', */ style: {
        backgroundColor: 'bg-warning',
        color: '#ffbe31',
        icon: 'question-mark-outline',
      },
      optimizationKey: 'BUY_OR_RENT',
    },
    borrowRp: {
      style: {
        backgroundColor: 'bg-warning',
        color: '#ffbe31',
        icon: 'question-mark-outline',
      },
      optimizationKey: '',
    },
    borrowInvest: {
      style: {
        backgroundColor: 'bg-warning',
        color: '#ffbe31',
        icon: 'question-mark-outline',
      },
      optimizationKey: '',
    },
    cashDeficit: {
      route: 'superfluity-fluidity',
      idProperty: `id`,
      style: { backgroundColor: 'bg-success', color: '#32c981', icon: 'euro' },
      optimizationKey: 'OPTIMIZE_CASH',
    },
    cashExcedent: {
      route: 'superfluity-fluidity',
      idProperty: `id`,
      style: { backgroundColor: 'bg-danger', color: '#eb7373', icon: 'euro' },
      optimizationKey: 'OPTIMIZE_CASH',
    },
    fiscality: {
      route: '/dashboard/taxes/overview',
      style: {
        backgroundColor: 'bg-danger',
        color: '#eb7373',
        icon: 'trending-down',
      },
      optimizationKey: 'OPTIMIZE_TAX',
    },
  };

  /* in order to emit data change */
  private emitNavbarNotifications$: Subject<any> = new BehaviorSubject<any>(
    null,
  );
  constructor(
    private httpApi: HttpApiService,
    private modalOptimizationService: ModalOptimizationService,
    private router: Router,
  ) {}

  emitNavbarNotifications() {
    this.emitNavbarNotifications$.next(this.items);
  }

  get getEmitNavbarNotificationsChange(): BehaviorSubject<any> {
    return this.emitNavbarNotifications$ as BehaviorSubject<any>;
  }

  /** Fetch notifications for the navbar
   */
  fetchNavbarNotifications(userId: any): any {
    this.httpApi
      .get(`/user/${userId}/data/notification/USER`)
      .pipe(map(res => res['data']))
      .subscribe((data: any) => {
        _.map(data.items, item => {
          item = _.assign(item, this.properties[item.value.type]);
        });

        this.items = data.items;
        return this.emitNavbarNotifications();
      });
  }

  goToNotification(notification: any) {
    // let relatedOptimization = _.find(this.optimizationsService.items, [
    //   "key",
    //   notification.optimizationKey,
    // ]);
    // if (notification.value && notification.value.type == "fiscality")
    //   this.router.navigate([`/dashboard/taxes/overview`]);
    // else if (relatedOptimization && relatedOptimization.value.length)
    //   this.modalOptimizationService.show(relatedOptimization);
    // else if (notification.current && notification.current.id)
    //   this.router.navigate([
    //     `/dashboard/optimizations/detail/${notification.route}/${notification.current.id}`,
    //   ]);
    // else if (relatedOptimization)
    //   this.router.navigate([
    //     `/dashboard/optimizations/detail/${notification.route}/${
    //       relatedOptimization[notification.idProperty]
    //     }`,
    //   ]);
    // else
    //   this.router.navigate([
    //     `/dashboard/optimizations/detail/${notification.route}/${notification.id}`,
    //   ]);
  }
}
